import { request } from './default'
import { useAuthStore } from '@/store'

export function fetchVehicleBrands() {
  return request({
    url: 'api/v1/vehicles/brands',
  })
}

export function getVehicleModelsQuery() {
  return request({
    url: 'api/v1/vehicles/models',
  })
}

export function fetchVehicleModels(brand_id: number) {
  return request({
    url: `api/v1/vehicles/brands/${brand_id}/models`,
  })
}

export function fetchVehicleEstimate(data: object) {
  return request({
    url: `api/v1/vehicles/estimate`,
    method: 'get',
    params: data,
  })
}

export function searchVehicleEstimate(data: object) {
  const { profile } = useAuthStore();

  data.currency = data.currency || profile?.owner?.currency || 'NGN';

  return request({
    url: `api/v1/vehicles/estimate/search`,
    method: 'get',
    params: data,
  })
}
